angular.module('logbook')
  .controller('markdown', ['$scope', '$http', '$location', '$rootScope', '$sce',
      function($scope, $http, $location, $rootScope, $sce ) {
         if( $location.search()['title'])
            $rootScope.title = $location.search()['title']; 
         $http.get($location.search()['document']).then(function(result) {
            $http.post('/api/markdown', {
               'markdown': result.data
            }).then(function(mdResult) {
               $scope.html = $sce.trustAsHtml(mdResult.data.html);
            })
            
         });
     }]);